import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

export interface Toast {
  id: number;
  key?: string;
  message?: string;
  translateMessage?: boolean;
  type: 'info' | 'success' | 'warning' | 'error';
}

export interface ToastStore {
  toasts: Toast[];

  addToast(toast: Omit<Toast, 'id'>): void;

  removeToast(toastId: number): void;
}

export const useToastStore = create<ToastStore>()(
  immer((set, get) => ({
    toasts: [] as Toast[],
    addToast(toast) {
      const id = Date.now();

      set((state) => {
        if (!toast.message) return;
        if (state.toasts.some((t) => toast.key === t.key)) return;

        state.toasts.push({
          ...toast,
          id,
        });
      });

      setTimeout(() => {
        get().removeToast(id);
      }, 1_800);
    },
    removeToast(toastId) {
      set((state) => {
        state.toasts = state.toasts.filter((t) => t.id !== toastId);
      });
    },
  })),
);

export const addToast = useToastStore.getState().addToast;

export const addTranslateToast = (toast: Omit<Toast, 'id' | 'translateMessage'>) =>
  useToastStore.getState().addToast({
    ...toast,
    translateMessage: true,
  });
export const removeToast = useToastStore.getState().removeToast;
